import { styled } from '@mui/material';

export const CompanySection = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  padding: 24px 40px 8px 40px;
`;
